<template lang="pug">
div
    AccountTreePicker(
        :accounts="accounts"
        :accountTypes="accountTypes"
        :idx="activeIdx"
        :show="activeTreePicker"
        @show="activeTreePicker = $event"
        @account:select="assignAccountFromPicker($event)"
        )
    //TODO: Pass props to picker and render the tree view
    v-form(ref="form")
        v-data-table.elevation-1(
            :items="_items"
            :headers="_headers"
            :rows-per-page-items="[-1]"
            hide-actions
            :loading="loading"
            )
            tr(slot="items" slot-scope="props")
                template(v-if="props.item.addVoucher && !lock")
                    td.pl-3(colspan="7")
                        v-btn( color="success" depressed @click="addRow()" )
                            v-icon add
                            span &nbsp;añadir
                template(v-else-if="props.item.totals")
                    td.font-weight-medium.subheading.text-xs-right( colspan="4" ) Totales:
                    td.font-weight-medium.subheading( :class="_balanceColor" ) {{_debtTotal | mixFormatCurrency}}
                    td.font-weight-medium.subheading( :class="_balanceColor" ) {{_receiveTotal | mixFormatCurrency}}
                    td
                template(v-else)
                    td.pl-4.pr-0
                        v-autocomplete.mx-0(
                            v-model="props.item.acc"
                            :ref="`field${1 + props.index * 4}`"
                            :disabled="lock"
                            :items="accountItems"
                            item-value="id"
                            append-outer-icon="search"
                            @click:append-outer="showTreePicker(props.index)"
                            hide-details
                            solo 
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )
                    td.px-0
                        v-autocomplete(
                            v-model="props.item.cost_center"
                            :disabled="lock"
                            :items="costCenterItems"
                            item-value="id"
                            hide-details
                            solo 
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )
                    td.px-0
                        v-text-field(
                            v-model="props.item.ref_document"
                            @blur="props.item.ref_document = fillEmptyWithZero(props.item.ref_document)"
                            :disabled="lock"
                            @keyup.enter="addRow"
                            hide-details
                            solo 
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )
                    td.px-0
                        v-text-field(
                            v-model="props.item.description"
                            @blur="props.item.description = fillEmptyWithZero(props.item.description)"
                            :disabled="lock"
                            @keyup.enter="addRow"
                            hide-details
                            solo 
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )
                    td.px-0
                        v-text-field(
                            v-model="props.item.debt"
                            :mask="mixCurrencyMask(props.item.debt, 12)"
                            @blur="props.item.debt = fillEmptyWithZero(props.item.debt)"
                            :disabled="lock"
                            @keyup.enter="addRow"
                            hide-details
                            solo 
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )               
                    td.px-0 
                        v-text-field(
                            v-model="props.item.receive"
                            :mask="mixCurrencyMask(props.item.receive, 12)"
                            @blur="props.item.debt = fillEmptyWithZero(props.item.debt)"
                            :disabled="lock"
                            @keyup.enter="addRow"
                            hide-details
                            solo
                            flat
                            style="border: 1px solid #eee; margin: 4px"
                        )
                    td.px-0
                        v-btn(v-if="!lock" :disabled="lock" icon @click="removeRow(props.index)")
                            v-icon(:color="colors.danger") delete
</template>

<script>
import { InputValidations, CurrencyUtils } from '@/mixins/reusable_mixins'
import AccountTreePicker from './AccountTreePicker'
export default {
    name: 'create-voucher-table',
    props: {
        /**
         * @description
         */
        items: {
            type: Array,
            default: () => [],
        },
        /**
         * @description
         */
        headers: {
            type: Array,
            default: () => [],
        },
        /**
         * @description
         */
        lock: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        accounts: {
            type: Array,
            default: () => [],
        },
        accountTypes: {
            type: Array,
            default: () => [],
        },
        costCenters: {
            type: Array,
            default: () => [],
        },
    },
    data: function() {
        return {
            tail: [
                {
                    addVoucher: true,
                },
                {
                    totals: true,
                },
            ],
            loading: true,
            accountItems: [],
            // parentAccounts: [],
            costCenterItems: [],
            // childrenAccounts: [],
            activeIdx: null,
            activeTreePicker: false,
        }
    },
    computed: {
        /**
         * @description
         */
        _items: {
            get: function() {
                return this.items.concat(this.tail)
            },
            set: function(val) {
                this.$emit('items:change', val)
            },
        },
        /**
         * @description
         */
        _headers: {
            get: function() {
                return this.headers
            },
            set: function(val) {
                this.$emit('headers:change', val)
            },
        },
        _debtTotal: function() {
            return (
                this.items.reduce(
                    (acc, itm) => acc + parseInt(itm.debt || 0),
                    0
                ) || 0
            )
        },
        _receiveTotal: function() {
            return (
                this.items.reduce(
                    (acc, itm) => acc + parseInt(itm.receive || 0),
                    0
                ) || 0
            )
        },
        _balanceColor: function() {
            if (this._debtTotal === 0 && this._receiveTotal === 0)
                return { 'black--text': true }
            if (this._debtTotal !== this._receiveTotal)
                return { 'red--text': true }
            if (this._debtTotal === this._receiveTotal)
                return { 'green--text': true }
        },
    },
    methods: {
        /**
         * @description
         */
        addRow: function() {
            let items = [...this.items]
            items.push({
                acc: '',
                cost_center: null,
                ref_document: '0',
                description: '',
                debt: 0,
                receive: 0,
            })
            this._items = [...items]
            this.$nextTick(() =>
                this.$refs[`field${1 + (this.items.length - 1) * 4}`].focus()
            )
        },
        /**
         * @description
         */
        removeRow: function(idx) {
            this.items = [...this.items.splice(idx, 1)]
            return
        },
        validate: function() {
            this.$refs.form.validate()
        },
        fillEmptyWithZero(val) {
            if (!val || val === '') {
                return 0
            }
            return val
        },
        filterAccounts: function() {
            let items = []
            this.accounts.forEach(account => {
                account = this.formatAccount(account)
                items.push(account)
            })
            this.accountItems = [...items]
            // let parentAccounts = []
            // let childrenAccounts = []
            // this.accounts.forEach(account => {
            //     account = this.formatAccount(account)
            //     console.log('id padre: ', account.acc_parent_id)
            //     if (!account.acc_parent_id) {
            //         parentAccounts.push(account)
            //     } else {
            //         childrenAccounts.push(account)
            //     }
            // })
            // this.parentAccounts = [...parentAccounts]
            // this.childrenAccounts = [...childrenAccounts]
        },
        filterCostCenters: function() {
            let costCenters = []
            this.costCenters.forEach(costCenter => {
                costCenter = this.formatCostCenter(costCenter)
                costCenters.push(costCenter)
            })
            this.costCenterItems = [...costCenters]
        },
        formatCostCenter: function(costCenter) {
            let costC = {...costCenter}
            costC.text = costC.name
            return costC
        },
        formatAccount: function(account) {
            let acc = { ...account }
            acc.text = acc.code + ' - ' + acc.comment
            return acc
        },
        showTreePicker: function(idx) {
            if(!this.lock){
                this.activeIdx = idx
                this.activeTreePicker = true
            }
        },
        assignAccountFromPicker: function(id) {
            let itm = [...this.items]
            itm[this.activeIdx].acc = id
            this.items = [...itm]
        },
    },
    watch: {
        accounts: {
            inmediate: true,
            handler: function() {
                if (!this.accounts || this.accounts.length === 0) {
                    this.loading = true
                } else {
                    this.loading = false
                    this.filterAccounts()
                }
            },
        },
        costCenters: {
            inmediate: true,
            handler: function(){
                if(!this.costCenters || this.costCenters.length === 0){
                    this.loading = true
                }
                else{
                    this.loading = false
                    this.filterCostCenters()
                }
            }
        },
    },
    components: {
        AccountTreePicker,
    },
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>